import React, { useEffect, useState } from "react";
import { Button } from "@vds/buttons";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import "../../styles/deviceStyle.css";
import UsersTable from "../../global/components/Tables/UsersTable";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchRequest,
} from "../../store/actions/alertsGroup";
import { fetchUserList, resetFilters } from "../../store/actions/user";
import CreateUserModel from "./CreateUser/CreateUserModal";

const Users = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const alertGroup = useSelector((state) => state.alertsGroup.data.alertsGroup);
  const userList = useSelector((state) => state.user.userList || []);
  const filters = useSelector((state) => state.user.filters);
  const tableLoading = useSelector((state) => state.user.isLoading);
  const [selectedUser, setSelectedUser] = useState();
  const [isModalVisible, setIsModalVisible] = useState(state?.createuser ?? false);
  const [hasInitiallyLoaded, setHasInitiallyLoaded] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  useEffect(() => {
    if (!hasInitiallyLoaded) {
      dispatch(resetFilters());
      dispatch(
        fetchUserList({
          accountName: sessionStorage.getItem("accountId"),
          currentrole: user?.role?.name || "ORG_ADMIN",
          searchName: [],
          searchEmail: [],
          roleFilter: [],
          searchFirstName: [],
          searchLastName: [],
          organizationFilter: [],
          sort: [{ field: "createdon", order: "desc" }],
          limit: 10,
          pageNo: 0,
        })
      );
      setHasInitiallyLoaded(true);
    }
  }, [dispatch, user?.accountId, hasInitiallyLoaded]);

  useEffect(() => {
    if (hasInitiallyLoaded) {
      dispatch(
        fetchUserList({
          accountName: sessionStorage.getItem("accountId"),
          currentrole: user?.role?.name || "ORG_ADMIN",
          ...filters,
        })
      );
    }
  }, [dispatch, filters, user?.accountId]);

  useEffect(() => {
  if (user?.accountId) {
    dispatch(resetFilters());
  }
}, [dispatch, user?.accountId]);

  const handleUserCreated = () => {
    setResetKey(prev => prev + 1);
    dispatch(resetFilters());
    dispatch(
      fetchUserList({
        accountName: sessionStorage.getItem("accountId"),
        currentrole: user?.role?.name || "ORG_ADMIN",
        searchName: [],
        searchEmail: [],
        roleFilter: [],
        searchFirstName: [],
        searchLastName: [],
        organizationFilter: [],
        sort: [
          {
            field: "createdon",
            order: "desc",
          },
        ],
      })
    );
  };
  const handleUserCreatedAdd = () => {
    setIsModalVisible(false);
    handleUserCreated();
  };

  const createUser = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div style={{ minHeight: "65vh", margin: "0 auto" }}>
      <Box sx={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h2
            className="page-common-heading_tittle"
          >
            Users
          </h2>
          <div style={{ alignContent: "end" }}>
            {user?.role?.permissions?.users?.create ? (
              <Button
                style={{
                  backgroundColor: "black",
                  color: "white",
                  fontSize: "16px",
                  lineHeight: '20px',
                  letterSpacing: '0.5px',
                  fontWeight: 700,
                }}
                size="large"
                use="primary"
                onClick={createUser}
              >
                Add user
              </Button>
            ) : null}
          </div>
        </div>
      </Box>
      {isModalVisible && (
        <CreateUserModel
          visible={isModalVisible}
          onClose={closeModal}
          onSave={closeModal}
          state={null}
          role_id={state?.role_Id}
          org_id={state?.org_id}
          onUserCreated={handleUserCreatedAdd}
        />
      )}
      <UsersTable
        userList={userList || []}
        resetKey={resetKey}
        alertGroup={alertGroup}
        isEditable={user?.role?.permissions?.users?.edit}
        permissions={user?.role?.permissions}
        userRoleName={user?.role?.name}
        pagination={{
          position: ["bottomRight"],
        }}
        setSelectedUser={setSelectedUser}
        selectedUser={selectedUser}
        tableLoading={tableLoading}
        tableTitle="Active roles"
        onUserCreated={handleUserCreated}
      />
    </div>
  );
};

export default Users;